export default "__VITE_ASSET__Jo2vhHFJ__"